export enum TicketIssueStatus {
  ISSUED = "ISSUED",
  PENDING = "PENDING",
}
